var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { ContentEntityThumbnailGrid } from './content-entity-thumbnail-grid';
import { EntityLinkButton } from './entity-link-button';
import { HeaderDivider } from '../elements/header-divider';
import { PAGE_KNOWLEDGE_HUB } from '../../constants';
import { classNames } from '../../utils/cn';
import { useActiveEntity } from '../../hooks/use-active-entity';
import { useLang } from '../../hooks/use-lang';
import { useFeedEntries } from '../../hooks/use-feed-entries';
import { usePosts } from '../../hooks/use-posts';
import { reverse, sortBy } from 'lodash';
var cls = classNames('slice-featured-posts');
export var SliceFeaturedPostsDefaultProps = {
  maxCount: 4
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    align-self: center;\n  "], ["\n    align-self: center;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(HeaderDivider)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Body: styled(ContentEntityThumbnailGrid).attrs(cls.attr('posts'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Link: styled(EntityLinkButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var SliceFeaturedPosts = function SliceFeaturedPosts(props) {
  var className = props.className,
      entity = props.entity,
      maxCount = props.maxCount;
  var page = useActiveEntity();
  var t = useLang();
  var feedEntries = useFeedEntries();
  var posts = usePosts();
  var items = reverse(sortBy(__spreadArray(__spreadArray([], __read(feedEntries), false), __read(posts), false), 'published'));
  var _a = page.featurePosts,
      featurePosts = _a === void 0 ? [] : _a;

  var allPosts = __spreadArray(__spreadArray([], __read(featurePosts), false), __read(items), false);

  if (!allPosts.length) return null;
  return React.createElement(My.Container, null, React.createElement(My.Header, null, t('Latest Articles & News')), React.createElement(My.Body, {
    items: allPosts.slice(0, maxCount),
    className: cls.name(className)
  }), React.createElement(My.Link, {
    entity: PAGE_KNOWLEDGE_HUB
  }, t("Visit Our Knowledge Hub")));
};
SliceFeaturedPosts.defaultProps = SliceFeaturedPostsDefaultProps;
SliceFeaturedPosts.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;